<span class="error-message-local">
  {{ data }}
</span>
